module.exports = __webpack_public_path__ + "img/IMG_8961.adcf6615.webp";